import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, NewspaperClipping } from "@phosphor-icons/react";
import { http, API_BASE } from "@/lib/api";

function abs(u) { return !u ? "" : u.startsWith("http") ? u : `${API_BASE}${u}`; }

/** RelatedReading — cross-links published CMS articles into any section.
 * `tag` matches cms_pages tags (e.g. docket tags: "science-pulse"). */
export default function RelatedReading({ tag, title = "From the reading room", testid = "related-reading", limit = 4, exclude = null }) {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    if (!tag) return;
    http.get("/cms/pages", { params: { page_type: "articles", tag, limit: limit + 1 } })
      .then(({ data }) => setPages((data.pages || []).filter((p) => p.slug !== exclude).slice(0, limit)))
      .catch(() => {});
  }, [tag, limit, exclude]);

  if (pages.length === 0) return null;

  return (
    <section className="mt-12" data-testid={testid}>
      <div className="flex items-center gap-2 font-mono-tech text-[10px] tracking-[0.28em] uppercase text-[#B85F2A]">
        <NewspaperClipping size={13} weight="fill" /> {title}
      </div>
      <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {pages.map((p) => (
          <Link key={p.slug} to={`/read/articles/${p.slug}`} data-testid={`${testid}-card-${p.slug}`}
            className="group rounded-2xl border border-black/10 bg-white overflow-hidden hover:-translate-y-0.5 hover:shadow-md transition-all">
            {p.cover_image && (
              <div className="h-28 overflow-hidden">
                <img src={abs(p.cover_image)} alt="" loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
            )}
            <div className="p-4">
              <div className="font-mono-tech text-[9px] tracking-[0.2em] uppercase text-[#B85F2A]">{p.category || "Article"}</div>
              <div className="mt-1 font-serif-display text-base leading-snug text-[#1B4332] line-clamp-2">{p.title}</div>
              <div className="mt-2 inline-flex items-center gap-1 font-mono-tech text-[9px] tracking-[0.18em] uppercase text-[#B85F2A]">
                Read <ArrowRight size={10} weight="bold" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
